import { UtilityService } from '../../utils/utility.service';

/**
 * The Logger Utility Service
 *
 * This service is used by Logger Service for preparing logging message
 */
export class LoggerUtilService {
  /**
   * Returns file name and line number of logging
   *
   * @returns
   */
  public static getCallerDetails(): { lineNumber: string; fileName: string } {
    try {
      throw new Error();
    } catch (err) {
      try {
        const callerLine = err.stack.split('\n')[4].split('/');
        const fileLineNumber = callerLine[callerLine.length - 1]
          .replace(/[()]/g, '')
          .replace('at', '')
          .replace(' eval code', '')
          .trim()
          .split(':');
        return {
          fileName: fileLineNumber[0],
          lineNumber: fileLineNumber[1]
        };
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
        return {
          fileName: null,
          lineNumber: null
        };
      }
    }
  }

  public static serializedRecord(record: unknown): string {
    let serializedRecord: string;
    try {
      serializedRecord = JSON.stringify(record, (_key: string, value: DOMException): DOMException => {
        if (this.isErrorWithStack(value)) {
          return UtilityService.deepExtend({ code: value.code, message: value.message, stack: value.stack }, value);
        }
        return value;
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      // serialization can fail if there are circular dependencies - fix this
      serializedRecord = JSON.stringify(this.getCopyWithoutCircularDependencies(record, { seenObject: [] }));
    }
    return serializedRecord;
  }

  public static isErrorWithStack(value: unknown): boolean {
    const isError = value instanceof Error;
    let isErrorObject: boolean;
    try {
      isErrorObject = (typeof value === 'object' &&
                      !!Object.getOwnPropertyDescriptor(value, 'message') &&
                      !!Object.getOwnPropertyDescriptor(value, 'stack'));
    } catch {
      isErrorObject = false;
    }
    return isError || isErrorObject;
  }

  public static getCopyWithoutCircularDependencies(fromObject: unknown, { seenObject }: { seenObject: Array<unknown> } ): unknown {
    const result = Array.isArray(fromObject) ? [] : {};

    for (const key of Object.keys(fromObject)) {
      const value = fromObject[key];
      if (typeof value !== 'function') {
        if (!value || typeof value !== 'object') {
          result[key] = value;
        } else if (this.isErrorWithStack(value)) {
          result[key] = value.toString();
        } else if (seenObject.indexOf(fromObject[key]) === -1) {
          seenObject.push(fromObject[key]);
          result[key] = this.getCopyWithoutCircularDependencies(fromObject[key], { seenObject });
        } else {
          result[key] = '[Circular reference]';
        }
      }
    }
    return result;
  }
}
